import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';

import { CompanyAgreementQuery, CompanyAgreementQueryVariables } from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { CompanyAgreementView, CompanyAgreementViewProps } from '../components/company_agreement';
import { companyAgreementQuery } from '../graphql';

class LoadingContainer extends Loader<
  CompanyAgreementQuery,
  CompanyAgreementViewProps,
  CompanyAgreementQueryVariables
> {}

export const CompanyAgreementContainer = () => {
  const { company_id: companyId } = useParams() as { company_id: string };

  const result = useQuery<CompanyAgreementQuery, CompanyAgreementQueryVariables>(companyAgreementQuery, {
    variables: { company_id: companyId },
    fetchPolicy: 'cache-and-network',
  });

  return (
    <LoadingContainer result={result} mapData={({ data }) => ({ agreement: data.company?.agreement ?? undefined })}>
      {({ agreement }) => <CompanyAgreementView agreement={agreement} />}
    </LoadingContainer>
  );
};
